/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { Heading, Button, useFlags } from 'sarsaparilla';
import a250LogoStyles from './A250PromoStyles.module.scss';
import a250Fireworks from './a250_fireworks.webp';

export function A250SearchPromoWrapper() {
    const { america250SearchPromo } = useFlags();

    if (!america250SearchPromo?.enabled) {
        return null;
    }

    return (
        <Button
            href="/articles/location-spotlight/Celebrating-America's-250th-Anniversary/1367"
            className={a250LogoStyles.a250PromoWrapper}
            isUnstyled
            aria-label="Celebrate 250 Years of American Discovery"
            gaReportName="Search promo for Freedom 250"
            gaReportCreative="Search promo for Freedom 250"
            gaReportPosition="Search Results"
            shouldReportToGA
        >
            <div className={a250LogoStyles.copyWrap}>
                <Heading
                    headingLevel={3}
                    appearance="h5"
                    className={a250LogoStyles.promoHeading}
                >
                    Celebrate 250 Years of American Discovery
                </Heading>
                <p>
                    Explore historic parks, cultural sites, scenic landscapes, and more as
                    you join the nationwide celebration of America&apos;s 250th
                    anniversary.
                </p>
            </div>

            <div className={a250LogoStyles.fireworksWrap}>
                <img
                    src={a250Fireworks}
                    alt=""
                    width={150}
                    height={146}
                    aria-hidden="true"
                />
            </div>
        </Button>
    );
}
